import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  InviteMessages,
  InviteMessagesMonitoring,
} from "../../../../../actions/websocket";
import {
  addMessage,
  AddNumberContact,
  editMsg,
  GetDetailsContacts,
  GetPhoneMidia,
  InsertUploadMonitoring,
  senfFileQuickAswMonitoring,
} from "../../../../../actions";
import MicroModal from "micromodal";
import moment from "moment";
import { connection_platform } from "../../../../../services/api";
import axios from "axios";
import { meses } from "../../../../../services/data";
import { saudacaoPorHorario } from "../../../../../utils/saudacaoPorHorario";

let gethostname = window.location.hostname;
let pathname = "";

let iplocal = connection_platform.ip_intern;
let port = connection_platform.port_backend_intern;
port = localStorage.getItem("port");

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

let ipcurrent = pathname;

if (pathname !== connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  //if(parseInt(connection_platform.port_apache_view_extern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

export const useMessageContainer = (
  setIsRecording,
  Mp3Recorder,
  setBlobURL,
  setSearchWord,
  searchWord
) => {
  const dispatch = useDispatch();

  const NpsDetails = useSelector((state) => state.npsdetails);
  const RespostasRapidas = useSelector((state) => state.respostas);
  const InfoUsers = useSelector((state) => state.informationusers);
  const MailMessage = useSelector((state) => state.messagemail);
  const Monitoring = useSelector((state) => state.monitoring);

  const [respostasinicial, setRespostasinicial] = useState([]);
  const [isBlocked, setIsBlocked] = useState(false);
  const [fileasw, setFileasw] = useState([]);
  const [record, setRecord] = useState(false);
  const [buttonQuickAnswer, setButtonQuickAnswer] = useState(false);
  const [respostas, setRespostas] = useState([]);
  const [isHSM, setIsHSM] = useState(false);
  const [editableQuickAnswer, setEditableQuickAnswer] = useState(false);
  const [messageQuickAnswer, setMessageQuickAnswer] = useState("");
  const [variableQuickAnwser, setVariableQuickAnwser] = useState([]);
  const [paramsHSM, setParamsHSM] = useState([]);
  const [checkparam, setCheckparam] = useState(false);
  const [checkparam2, setCheckparam2] = useState(false);
  const [searchQuickMsg, setSearchQuickMsg] = useState("");
  const [timerecording, setTimerecording] = useState(-1);
  const [selectedFile, setSelectedFile] = useState([]);
  const [loaded, setLoaded] = useState(null);

  function createJSON(item) {
    if (item) {
      var mensagem_tratada = item.replace(/¿/gi, "\n");
      mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
      let valor = 1;
      try {
        mensagem_tratada =
          '{"' +
          valor +
          '": [{"mensagem_tratada":"' +
          mensagem_tratada +
          '"}]}';
        var obj = JSON.parse(mensagem_tratada);
        mensagem_tratada = obj[1][0].mensagem_tratada;
      } catch (e) {
        mensagem_tratada = item;
      }
      return mensagem_tratada;
    }
  }
  const sendTextInputChat = (textReceived) => {
    document.getElementById("chat-message").innerText = textReceived;
  };
  const actionCancelMessageClient = () => {
    MicroModal.close("modal__mensagens-predefinidas-monitoring");
    document.getElementById("chat-message").innerText = "";
  };
  const actionSendMessageClient = (bind) => {
    MicroModal.close("modal__mensagens-predefinidas-monitoring");
    document.getElementById("button-send-message").click();
    document.getElementById("input-msgs-rapidas").value = "";
    // bind.setState({ searchQuickMsg: "" });
    setSearchQuickMsg("");
  };
  const changeVariablesSending = (array) => {
    // arrayVariables = array;
    // document.getElementById("button-save-variables").click();
    setVariableQuickAnwser(array);
  };
  const scrollDown = () => {
    const scrollableDiv = document.querySelector(".chat-window");

    // scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
    requestAnimationFrame(() => {
      scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
    });
  };
  const InviteMessage = (
    makeid,
    message,
    author,
    infousers,
    contactid,
    typemsg,
    msgsocket,
    line
  ) => {
    let time = moment().format("HH:mm");
    let dia = moment().format("DD");
    let mes = moment().format("MM");
    let ano = moment().format("YYYY");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    if (message != "") {
      dispatch(
        addMessage(
          makeid,
          message,
          author,
          time,
          contactid.idatendimento,
          typemsg,
          "entregue",
          false,
          dia,
          infousers.username,
          "",
          "",
          line,
          "",
          "",
          "",
          ano,
          moment().format("DD/MM/YYYY HH:mm")
        ),
        InviteMessagesMonitoring(
          infousers,
          contactid,
          msgsocket,
          author,
          makeid,
          line
        )
      );
    }
  };
  const sendImageAsw = (
    makeid,
    message,
    author,
    infousers,
    contactid,
    typemsg,
    line
  ) => {
    let time = moment().format("HH:mm");
    let dia = moment().format("DD");
    let mes = moment().format("MM");
    let ano = moment().format("YYYY");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    if (message != "") {
      dispatch(
        addMessage(
          makeid,
          message,
          author,
          time,
          contactid.idatendimento,
          typemsg,
          "entregue",
          false,
          dia,
          infousers.username,
          "",
          "",
          line,
          "",
          "",
          "",
          ano,
          moment().format("DD/MM/YYYY HH:mm")
        )
      );
    }
  };
  const handleKeyUp = (direction) => {
    const elems = document.getElementsByTagName("mark");
    const total = elems.length;
    let current = searchWord.atual;

    if (total === 0) return;

    if (direction === "less") {
      current = (current - 1 + total) % total;
    } else if (direction === "more") {
      current = (current + 1) % total;
    }
    setSearchWord({ ...searchWord, atual: current });
    elems[current].scrollIntoView({ block: "center", behavior: "smooth" });
  };
  const handleKeyPress = (event) => {
    var el = document.getElementById("chat-message");
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };
  const audioStart = () => {
    // this.setState({
    //   record: true,
    //   timerecording: 0,
    // });
    setRecord(true);
    setTimerecording(0);
    if (isBlocked) {
    } else {
      Mp3Recorder.start()
        .then(() => {
          // this.setState({ isRecording: true });
          setIsRecording(true);
        })
        .catch((e) => console.error(e));
    }
  };
  const filterList = (event, respostas) => {
    let updatedList = respostas;
    updatedList = updatedList.filter(function (item) {
      let asw = item.qck_asw_keyword;
      let filtro = event.target.value;
      let er = /[^a-z0-9]/gi;
      filtro = filtro.replace(er, "");
      let resultado = asw.search(filtro);
      return asw.toLowerCase().search(filtro.toLowerCase()) != -1;
    });
    // this.setState({ respostas: updatedList });
    setRespostas(updatedList);
  };
  const handleKeyDown = (event) => {
    var el = document.getElementById("chat-message");
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };
  function makeid(length) {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }
  const addNumberContact = (post, number) => {
    dispatch(AddNumberContact(post, number));
    dispatch(GetPhoneMidia([]));
  };
  const handleAddContact = (contact, typeModal, bind) => {
    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontacts?number=${contact.telefone}&nome=&empresa=&contato=&codext=&email=`
      )
      .then((response) => {
        if (response.data.length > 0) {
          if (typeModal === "link") {
            MicroModal.show("modal__linkAdd-contact");
            dispatch(GetDetailsContacts(false, response.data[0]));
          } else {
            dispatch(GetDetailsContacts(true, response.data[0], ""));
          }
        } else {
          if (typeModal === "link") {
            MicroModal.show("modal__linkAdd-contact");
            dispatch(GetDetailsContacts(false, contact));
          } else {
            dispatch(GetDetailsContacts(true, "", contact));
            addNumberContact("", contact.telefone);
          }
        }
        // this.setState({ cursorState: false });
      });
  };
  const ButtonSendMessage = (
    event,
    author,
    InfoUsers,
    ContactId,
    typemsg,
    line
  ) => {
    event.preventDefault();
    document.getElementById("chat-message").disabled = false;
    let msgweb = document.getElementById("chat-message").innerText;
    let msgsocket = document.getElementById("chat-message").innerText;

    let infosendfile = fileasw;

    if (fileasw != null && infosendfile[2] != 1 && infosendfile.length > 0) {
      msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
      msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        if (infosendfile[0] != "") {
          senfFileQuickAswMonitoring(
            InfoUsers,
            ContactId,
            infosendfile[0],
            msgweb,
            makeid(32),
            line
          );
        }
        sendImageAsw(
          makeid(32),
          " ~¿" + msgweb + "~¿" + infosendfile[0],
          "Me",
          InfoUsers,
          ContactId,
          1,
          line
        );
      }
    } else {
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        InviteMessages(
          makeid(32),
          msgweb,
          "Me",
          InfoUsers,
          ContactId,
          typemsg,
          msgsocket,
          line
        );
      }
    }
    scrollDown();
    document.getElementById("chat-message").innerHTML = "";
  };
  const handleOnChange = (event, InfoUsers, ContactId, line) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      let teste = document.getElementsByClassName("chat-message");
      let msgweb = document.getElementById("chat-message").innerText;
      let msgsocket = document.getElementById("chat-message").innerText;
      let infosendfile = fileasw;

      if (fileasw != null && infosendfile[2] != 1 && infosendfile.length > 0) {
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        let str = msgweb.replace(/\s/g, "");
        if (str != "") {
          if (infosendfile[0] != "") {
            senfFileQuickAswMonitoring(
              InfoUsers,
              ContactId,
              infosendfile[0],
              msgweb,
              makeid(32),
              line
            );
          }
          sendImageAsw(
            makeid(32),
            " ~¿" + msgweb + "~¿" + infosendfile[0],
            "Me",
            InfoUsers,
            ContactId,
            1,
            line
          );
        }

        document.getElementById("chat-message").innerHTML = "";
        scrollDown();
      } else {
        let str = msgweb.replace(/\s/g, "");
        if (str != "") {
          msgweb = msgweb.trim();
          msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
          msgsocket = msgsocket.trim();
          msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
          InviteMessage(
            makeid(32),
            msgweb,
            "Me",
            InfoUsers,
            ContactId,
            "0",
            msgsocket,
            line
          );
          document.getElementById("chat-message").innerHTML = "";
          scrollDown();
          // this.props.sendtyping(0, InfoUsers, ContactId);NÃO MANDAR TYPPINY POR ENQUANTO
        }
      }
    }
  };
  const sendMesssageV2 = (event, InfoUsers, ContactId, line) => {
    let teste = document.getElementsByClassName("chat-message");
    let msgweb = document.getElementById("chat-message").innerText;
    let msgsocket = document.getElementById("chat-message").innerText;
    let infosendfile = fileasw;

    if (fileasw != null && infosendfile[2] != 1 && infosendfile.length > 0) {
      msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
      msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        if (infosendfile[0] != "") {
          senfFileQuickAswMonitoring(
            InfoUsers,
            ContactId,
            infosendfile[0],
            msgweb,
            makeid(32),
            line
          );
        }
        sendImageAsw(
          makeid(32),
          " ~¿" + msgweb + "~¿" + infosendfile[0],
          "Me",
          InfoUsers,
          ContactId,
          1,
          line
        );
      }

      document.getElementById("chat-message").innerHTML = "";
      scrollDown();
    } else {
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        InviteMessage(
          makeid(32),
          msgweb,
          "Me",
          InfoUsers,
          ContactId,
          "0",
          msgsocket,
          line
        );
        document.getElementById("chat-message").innerHTML = "";
        scrollDown();
        // this.props.sendtyping(0, InfoUsers, ContactId);NÃO MANDAR TYPPINY POR ENQUANTO
      }
    }
  };
  const DisplayQuickAnswer = (e) => {
    e.preventDefault();
    setButtonQuickAnswer(!buttonQuickAnswer);
    // this.setState({ buttonQuickAnswer: !this.state.buttonQuickAnswer });
    // const { RespostasRapidas } = this.props;
    // this.state.respostasinicial = RespostasRapidas.respostas;

    setRespostasinicial(RespostasRapidas.respostas);
    // this.state.respostas = this.state.respostasinicial;
    setRespostas(RespostasRapidas.respostas);
  };
  const InsertQuickAnswer = (
    event,
    texto,
    editable,
    mimetypeid,
    filepath,
    InfoUsers,
    ContactId,
    resp
  ) => {
    event.preventDefault();

    let textReceived = texto;
    let checksocialname = texto.indexOf(`{SYS.SOCIALNAME}`);
    let checkNumProtocol = texto.indexOf(`{SYS.PROTOCOLO}`);
    let checkvalueSName = false;
    // this.setState({ isHSM: false });
    // this.setState({ editableQuickAnswer: false });
    setIsHSM(false);
    setEditableQuickAnswer(false);

    let checkvalueSProtocol = false;

    if (checksocialname > 0) {
      checkvalueSName = true;
    } else {
      checkvalueSName = false;
    }

    if (checkNumProtocol > 0) {
      checkvalueSProtocol = true;
    } else {
      checkvalueSProtocol = false;
    }

    let checknomeagente = texto.indexOf(`{SYS.NOMEAGENTE}`);
    let checkvalueNAgent = false;
    if (checknomeagente > 0) {
      checkvalueNAgent = true;
    } else {
      checkvalueNAgent = false;
    }

    texto = texto.replace(
      "${SYS.SOCIALNAME}",
      createJSON(ContactId.cliente.trim())
    );
    texto = texto.replace(
      "${SYS.NOMEAGENTE}",
      createJSON(InfoUsers.displayname.trim())
    );
    const saudacao = saudacaoPorHorario();
    texto = texto.replace("${SYS.GREETING}", createJSON(saudacao.trim()));
    texto = texto.replace("${SYS.SAUDACAO}", createJSON(saudacao.trim()));

    if (NpsDetails.length !== 0) {
      const filterNpsClientDetails = NpsDetails.filter(
        (nps) => nps.numero_cliente === ContactId.telefone
      );

      if (filterNpsClientDetails.length !== 0) {
        texto = texto.replace(
          "${CAMP.NOMECLIENTE}",
          createJSON(filterNpsClientDetails[0].nome_cliente)
        );
      }
    }

    if (checkvalueSProtocol && ContactId.protocolo) {
      texto = texto.replace(
        "${SYS.PROTOCOLO}",
        createJSON(ContactId.protocolo.trim())
      );
    }

    try {
      let regex = new RegExp("{(.*?)}", "g");
      let result;
      let array = [];

      while ((result = regex.exec(textReceived))) {
        let value = result[1];
        value = value.replace(
          "SYS.SOCIALNAME",
          createJSON(ContactId.cliente.trim())
        );
        value = value.replace(
          "SYS.NOMEAGENTE",
          createJSON(InfoUsers.displayname.trim())
        );

        value = value.replace("SYS.GREETING", createJSON(saudacao.trim()));
        value = value.replace("SYS.SAUDACAO", createJSON(saudacao.trim()));

        if (NpsDetails.length !== 0) {
          const filterNpsClientDetails = NpsDetails.filter(
            (nps) => nps.numero_cliente === ContactId.telefone
          );
          if (filterNpsClientDetails.length !== 0) {
            value = value.replace(
              "CAMP.NOMECLIENTE",
              createJSON(filterNpsClientDetails[0].nome_cliente)
            );
          }
        }

        if (ContactId.protocolo) {
          value = value.replace(
            "SYS.PROTOCOLO",
            createJSON(ContactId.protocolo.trim())
          );
        }
        array.push({
          id: result[1],
          name: result[1],
          value: value === result[1] ? "${" + value + "}" : value,
        }); // mostra o que está entre os :
      }

      if (
        array.length !== 0 &&
        (mimetypeid >= 30 || mimetypeid === 1) &&
        editable === true
      ) {
        MicroModal.show("modal__mensagens-predefinidas-monitoring");
        // this.setState({
        //   messageQuickAnswer: textReceived,
        //   variableQuickAnwser: array,
        // });
        setMessageQuickAnswer(textReceived);
        setVariableQuickAnwser(array);
      }
    } catch {
      console.log("ERROR");
    }

    document.getElementById("chat-message").innerText = texto;
    // this.props.editMsg(texto, ContactId.idatendimento);
    dispatch(editMsg(texto, ContactId.idatendimento));

    if (mimetypeid != 1) {
      if (mimetypeid >= 30 && mimetypeid <= 38) {
        // this.setState({
        //   isHSM: true,
        //   paramsHSM: resp,
        //   checkparam: checkvalueSName,
        //   checkparam2: checkvalueNAgent,
        // });
        setIsHSM(true);
        setParamsHSM(resp);
        setCheckparam(checkvalueSName);
        setCheckparam2(checkvalueNAgent);

        if (mimetypeid === 38 || mimetypeid === 31) {
          let arrayfile = [filepath, texto, mimetypeid];
          // this.setState({ fileasw: [] });
          // this.setState({ fileasw: arrayfile });
          setFileasw(arrayfile);
        }
      } else {
        let gerarnomearquivo = makeid(32);
        let photo = {
          uri: filepath,
          type: "application/pdf",
          name: gerarnomearquivo + ".pdf",
        };
        let fileencryp = new FormData();
        fileencryp.append("file", gerarnomearquivo + ".pdf");
        //fileencryp.append('file', photo, gerarnomearquivo+".pdf");
        let arrayfile = [filepath, texto, mimetypeid];
        // this.setState({ fileasw: [] });
        // this.setState({ fileasw: arrayfile });
        setFileasw(arrayfile);
      }
    } else {
      // this.setState({ fileasw: [] });
      setFileasw([]);
    }
    if (editable == false) {
      document.getElementById("chat-message").disabled = true;
      document.getElementById("chat-message").contentEditable = false;
      // this.setState({ editableQuickAnswer: true });
      setEditableQuickAnswer(true);
    } else {
      document.getElementById("chat-message").disabled = false;
      document.getElementById("chat-message").contentEditable = true;
      document.getElementById("chat-message").focus();
    }
    // this.setState({
    //   buttonQuickAnswer: !this.state.buttonQuickAnswer,
    //   searchQuickMsg: "",
    // });
    setButtonQuickAnswer(!buttonQuickAnswer);
    setSearchQuickMsg("");

    document.getElementById("input-msgs-rapidas").value = "";

    //this.setState({ fileasw: [] });
  };
  const handleselectedFile = (event, infousers, contactid, line) => {
    let filesend = event.target.files[0];
    if (filesend != undefined) {
      // this.setState({
      //   selectedFile: filesend,
      //   loaded: 0,
      // });
      setSelectedFile(filesend);
      setLoaded(0);

      let data = new FormData();
      let namefile = filesend.name;
      let hora = moment().format("HH-mm-ss");
      let random = Math.floor(Math.random() * 999999 + 100000);
      random = random + "_" + hora;
      let ext = namefile.split(".").pop();
      namefile = random + "." + ext;
      data.append("file", filesend, namefile);
      let msgweb = document.getElementById("chat-message").innerText;
      let msgsocket = document.getElementById("chat-message").innerText;
      let str = msgsocket.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        document.getElementById("chat-message").innerHTML = "";
        // this.props.UploadFile(
        //   data,
        //   infousers,
        //   contactid,
        //   msgweb,
        //   makeid(32),
        //   filesend.size,
        //   line
        // );
        dispatch(
          InsertUploadMonitoring(
            data,
            infousers,
            contactid,
            msgweb,
            makeid(32),
            filesend.size,
            line
          )
        );
      } else {
        // this.props.UploadFile(
        //   data,
        //   infousers,
        //   contactid,
        //   "",
        //   makeid(32),
        //   filesend.size,
        //   line
        // );
        dispatch(
          InsertUploadMonitoring(
            data,
            infousers,
            contactid,
            "",
            makeid(32),
            filesend.size,
            line
          )
        );
      }
    }
    document.getElementById("file-input").value = "";
  };
  const audioStopIn = () => {
    // this.setState({
    //   record: false,
    // });
    setRecord(false);
    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        // const blobURL = URL.createObjectURL(blob)
        const blobURL = blob;
        // this.setState({ blobURL, isRecording: true });
        setBlobURL(blobURL);
        setIsRecording(true);
      })
      .catch((e) => console.log(e));
  };
  const audioStop = () => {
    // this.setState({
    //   record: false,
    //   blobURL: "",
    // });
    setRecord(false);
    setBlobURL("");
    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        // this.setState({ isRecording: false });
        setIsRecording(false);
      })
      .catch((e) => console.log(e));
  };

  // useEffect(() => {
  //   if (isToFindTheTerm.isToFind) {
  //     setOpenSearch(true);
  //     getTermText({ target: { value: isToFindTheTerm.searchTerm } });

  //     // setTimeout(() => {
  //     //   getTermText({ target: { value: isToFindTheTerm.searchTerm } });
  //     // }, 100);
  //   }
  // }, [isToFindTheTerm, Messages[selectedChat.idatendimento]]);

  return {
    Monitoring,
    handleKeyPress,
    handleKeyDown,
    handleOnChange,
    InfoUsers,
    DisplayQuickAnswer,
    InsertQuickAnswer,
    filterList,
    respostasinicial,
    handleselectedFile,
    audioStart,
    audioStop,
    audioStopIn,
    ButtonSendMessage,
    MailMessage,
    dispatch,
    handleAddContact,
    handleKeyUp,
    record,
    buttonQuickAnswer,
    respostas,
    messageQuickAnswer,
    changeVariablesSending,
    variableQuickAnwser,
    actionSendMessageClient,
    actionCancelMessageClient,
    sendTextInputChat,
    timerecording,
    createJSON,
    sendMesssageV2,
  };
};
